import { Code, IconCatalog, IconScale } from '~/design-system';
import { getApi } from '~/platform/data/apiSingleton';
import type { ModuleDefinition } from '~/platform/registry/types';

export const catalogModule: ModuleDefinition = {
  id: 'catalog',
  i18nNamespace: 'catalog',
  requires: { subject: 'product', action: 'read' },

  nav: {
    labelKey: 'catalog:nav',
    icon: IconCatalog,
    to: 'catalog',
    group: 'trade',
    order: 30,
  },

  routes: [{ path: 'catalog', component: () => import('./CatalogPage') }],

  search: async (query, { businessId }) => {
    const products = await getApi().listProducts(businessId, { search: query });
    return products.slice(0, 6).map((product) => ({
      id: product.id,
      moduleId: 'catalog' as const,
      code: product.sku,
      title: product.name['en'] ?? product.sku,
      subtitle: product.traits.origin?.region ?? undefined,
      handlingClass: product.handlingClass,
      stamp: <Code>{product.salesUnit}</Code>,
      to: `/b/${product.businessId}/catalog?product=${product.id}`,
    }));
  },
};

/**
 * The write side of the catalog is a separate module on purpose: a
 * salesperson needs `catalog:read` all day and must never be one
 * mis-click from editing a price list, and a tenant can switch the
 * manager off entirely without losing the browsing view.
 */
export const productsModule: ModuleDefinition = {
  id: 'products',
  i18nNamespace: 'products',
  requires: { subject: 'product', action: 'update' },

  nav: {
    labelKey: 'products:nav',
    icon: IconScale,
    to: 'products',
    group: 'trade',
    order: 40,
  },

  routes: [{ path: 'products', component: () => import('./ProductsPage') }],

  commands: [
    {
      id: 'products.new',
      labelKey: 'products:newProduct',
      groupKey: 'products:title',
      requires: { subject: 'product', action: 'create' },
      run: ({ businessSlug, navigate }) => navigate(`/b/${businessSlug}/products?new=1`),
    },
  ],
};
